// =========================
// APP.JS
// =========================

import Router from './Router';
import Auth from './Auth';

// This is the main application class that initializes the app and sets up the API base URL.
// It also handles the root element where the app will be rendered.
class App {
  constructor() {
    this.name = 'PopIn';
    this.version = '1.0.0';
    this.apiBase = process.env.API_BASE || 'http://localhost:3000';
    this.rootEl = document.getElementById('root');
    console.log(`Using API base: ${this.apiBase}`);
  }

  // This method initializes the app by checking the authentication status and then
  // initializing the router.
  init() {
    console.log('App.init');

    Auth.check(() => {
      Router.init();
    });
  }
}

export default new App();
